import React, { useEffect } from 'react';

import { useAppSelector } from '../../store/hooks';
import { useSnackbar } from 'notistack';

const Notification = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { notifications } = useAppSelector(state => state.notification);

  useEffect(() => {
    if (notifications.length) {
      const index = notifications.length - 1;
      const newNotification = notifications[index];

      enqueueSnackbar(newNotification.message, {
        variant: newNotification.type,
        autoHideDuration: 3000,
        preventDuplicate: true,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      });
    }
  }, [enqueueSnackbar, notifications]);

  return <></>;
};

export default Notification;
